import { ref } from 'vue'

const notification = ref({
  show: false,
  message: '',
  type: 'success' // 'success' o 'error'
})

export function useNotification() {
  const notify = (message, type = 'success') => {
    notification.value = {
      show: true,
      message,
      type
    }

    // Ocultar automáticamente después de 4 segundos
    setTimeout(() => {
      notification.value.show = false
    }, 4000)
  }

  return {
    notification,
    notify
  }
}